import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Duofix from '../../../assets/img/Duofix.png';
import GIS from '../../../assets/img/GIS.png';
import Kombix from '../../../assets/img/Kombix.png';
import { FormattedHTMLMessage } from 'react-intl';

export default class installationssystem extends React.Component {
    render() {
        return (
            <Wrapper>
                <RowSpace>
                    <ImageModal src={Duofix} alt="" title="" />
                    <HeadLine>
                        <FormattedHTMLMessage id="Header_Duofix" />
                    </HeadLine>
                    <SubHeadLine>
                        <FormattedHTMLMessage id="SubHeader_Duofix" />
                    </SubHeadLine>
                    <TextField>
                        <FormattedHTMLMessage id="TextBlock_Duofix" />
                    </TextField>
                </RowSpace>

                <RowSpace>
                    <ImageModal src={GIS} alt="" title="" />
                    <HeadLine>
                        <FormattedHTMLMessage id="Header_GIS" />
                    </HeadLine>
                    <SubHeadLine>
                        <FormattedHTMLMessage id="SubHeader_GIS" />
                    </SubHeadLine>
                    <TextField>
                        <FormattedHTMLMessage id="TextBlock_GIS" />
                    </TextField>
                </RowSpace>

                <RowSpace>
                    <ImageModal src={Kombix} alt="" title="" />
                    <HeadLine>
                        <FormattedHTMLMessage id="Header_Kombix" />
                    </HeadLine>
                    <SubHeadLine>
                        <FormattedHTMLMessage id="SubHeader_Kombix" />
                    </SubHeadLine>
                    <TextField>
                        <FormattedHTMLMessage id="TextBlock_Kombix" />
                    </TextField>
                </RowSpace>
            </Wrapper>
        );
    }
}
const Wrapper = styled.div`
font-family:GROTESK Regular;
font-size:15px;
line-height:20px;
font-weight:100;
`;
const RowSpace = styled.div`
    margin-top: 0;
    color: black;
    padding: 2%;
    width: 33.3%;
    float: left;
    @media (max-width: 600px) {
        padding: 4%;
        width: 93%;
    }
`;
const ImageModal = styled.img`
    max-width: 100%;
    width: 100%;
    display: block;
    height: 16rem;
    object-fit: cover;
    box-shadow: 0 0 0.4rem #999999;
    z-index: 20;
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        width: auto;
    }
`;
const HeadLine = styled.div`
    color: black;
    line-height:20px;
    font-size: 15px;
    font-weight: 700;
    margin-top: 0.5rem;
    padding: 4%;
    text-transform: uppercase;
`;
const SubHeadLine = styled.div`
    color: black;
    line-height:20px;
    font-size: 15px;
    font-weight: 500;
    padding: 4%;
    text-transform: uppercase;
`;
const TextField = styled.div`
    margin-bottom: 0.5rem;
    color: black;
    font-size: 15px;
    line-height:20px;
    padding: 4%;
    word-break: break-word;
`;
